__turbopack_context__.v({
  "blok-big-title": "modal-module__o5Wrwa__blok-big-title",
  "blok-subtitle": "modal-module__o5Wrwa__blok-subtitle",
  "blok-title": "modal-module__o5Wrwa__blok-title",
  "modal": "modal-module__o5Wrwa__modal",
  "modalIn": "modal-module__o5Wrwa__modalIn",
});
